<template>
  <fieldset :disabled="isBlockReadOnly" class="block-fieldset">
    <slot />
  </fieldset>
</template>

<script>
import { AccessBlockMixin } from '@/mixins/accessBlock';

/**
 * Root of a block component (ADR 0006 D4, revised 2026-10-07): disables the block's native
 * form controls when the surrounding `AccessBlock` provides read-only. Frames of the view
 * stay outside and usable.
 */
export default {
  name: 'BlockFieldset',
  mixins: [AccessBlockMixin],
};
</script>

<style scoped>
.block-fieldset {
  min-width: 0;
  margin: 0;
  padding: 0;
  border: 0;
}
</style>
